// extracted by mini-css-extract-plugin
module.exports =  {"control":"yW3OHpL"};